import type { Buffer } from "../model/buffer";
import { lastLineIndex, lastNormalModeCol, lineLength } from "../model/buffer";
import type { Cursor } from "../model/cursor";
import type { Range } from "../model/range";

function withCount(count: number | null): number {
  return Math.max(count ?? 1, 1);
}

/** `h`: カーソルを左へcount回移動する。exclusive。 */
export function moveLeft(_buffer: Buffer, cursor: Cursor, count: number | null): Range {
  const col = Math.max(cursor.col - withCount(count), 0);
  return { start: cursor, end: { line: cursor.line, col }, kind: "exclusive" };
}

/** `l`: カーソルを右へcount回移動する。exclusive。 */
export function moveRight(buffer: Buffer, cursor: Cursor, count: number | null): Range {
  const maxCol = lastNormalModeCol(buffer, cursor.line);
  const col = Math.min(cursor.col + withCount(count), maxCol);
  return { start: cursor, end: { line: cursor.line, col }, kind: "exclusive" };
}

/** `j`: カーソルをcount行下へ移動する。linewise。 */
export function moveDown(buffer: Buffer, cursor: Cursor, count: number | null): Range {
  const line = Math.min(cursor.line + withCount(count), lastLineIndex(buffer));
  const col = Math.min(cursor.col, lastNormalModeCol(buffer, line));
  return { start: cursor, end: { line, col }, kind: "linewise" };
}

/** `k`: カーソルをcount行上へ移動する。linewise。 */
export function moveUp(buffer: Buffer, cursor: Cursor, count: number | null): Range {
  const line = Math.max(cursor.line - withCount(count), 0);
  const col = Math.min(cursor.col, lastNormalModeCol(buffer, line));
  return { start: cursor, end: { line, col }, kind: "linewise" };
}

/** `0`: 行頭へ移動する。exclusive。 */
export function lineStart(_buffer: Buffer, cursor: Cursor, _count: number | null): Range {
  return { start: cursor, end: { line: cursor.line, col: 0 }, kind: "exclusive" };
}

/** `^`: 行の最初の非空白文字へ移動する。exclusive。 */
export function firstNonBlank(buffer: Buffer, cursor: Cursor, _count: number | null): Range {
  return {
    start: cursor,
    end: { line: cursor.line, col: firstNonBlankCol(buffer, cursor.line) },
    kind: "exclusive",
  };
}

/** `$`: 行末へ移動する。countを指定すると(count-1)行下の行末へ移動する。inclusive。 */
export function lineEnd(buffer: Buffer, cursor: Cursor, count: number | null): Range {
  const line = Math.min(cursor.line + withCount(count) - 1, lastLineIndex(buffer));
  return {
    start: cursor,
    end: { line, col: lastNormalModeCol(buffer, line) },
    kind: "inclusive",
  };
}

export function firstNonBlankCol(buffer: Buffer, line: number): number {
  const text = buffer.lines[line] ?? "";
  const length = lineLength(buffer, line);
  for (let col = 0; col < length; col += 1) {
    if (!/\s/.test(text[col] as string)) {
      return col;
    }
  }
  return 0;
}
